// lib
import jwt from "jsonwebtoken";
// src
import * as actions from "actions/user";
import { DAY } from "config/constants";
import { hydrateSlice } from "actions/system";
import { buildStorageAdapters, clearStorage } from "utils/storage";

const maxAge = 7 * DAY;
const saveDelay = 10;
const [hydrate, save] = buildStorageAdapters("user", {
  maxAge,
  saveDelay,
  blacklist: ["isStateInitialized"],
});

const DEFAULT_STATE = {
  identity: {},
  idop: null,
  isLogged: false,
  isStateInitialized: false,
  redirectTarget: null,
  token: null,
};

export default (state = DEFAULT_STATE, { type, payload }) => {
  // order actions by frequency
  switch (type) {
    case hydrateSlice.toString(): {
      return hydrate(state, payload);
    }
    case actions.backTokenSuccess.toString(): {
      const { identity, token } = payload;
      const decoded = jwt.decode(token);
      const idop = decoded && decoded.idop;
      const newState = {
        ...state,
        idop,
        identity,
        token,
        isLogged: true,
      };
      return save(newState);
    }
    case actions.userStateSuccess.toString(): {
      return {
        ...state,
        isStateInitialized: true,
      };
    }
    case actions.setRedirect.toString(): {
      const newState = { ...state, redirectTarget: payload };
      return save(newState);
    }
    case actions.resetRedirect.toString(): {
      const newState = { ...state, redirectTarget: null };
      return save(newState);
    }
    case actions.disconnect.toString(): {
      clearStorage();
      return DEFAULT_STATE;
    }
    default:
      return state;
  }
};
